// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ko-0";